module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Memoirs of the Target")]), _c('ol', {
    staticClass: "toc",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgemetn"
    }
  }, [_vm._v("Acknowledgemetn")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#chapter-1-the-smirk-that-lies-beneath"
    }
  }, [_vm._v("Chapter 1: The Smirk That Lies Beneath")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#chapter-2-which-hat",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2: Which Hat")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#chapter-3-80-spaces",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: 80 Spaces")])]), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#chapter-4-the-godmother",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: The Godmother")])]), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#chapter-5-speed-dating",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: Speed Dating")])]), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#chapter-6-white-knight-of-the-white-light",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: White Knight of the White Light")])]), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#chapter-7-i-am-not-a-cat",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: I Am Not a Cat")])]), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#chapter-8-prison-break-rise-of-the-phoenix",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: Prison Break Rise of the Phoenix")])]), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#chapter-9-the-final-curtain-call-or-so-we-thought",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: The Final Curtain Call or So We Thought!")])]), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#chapter-10-tribute-to-vincent",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: Tribute to Vincent")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-206d183d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0